import { LinkConnection } from "../Topology/LinkConnection";
import { DeviceNode } from "../Topology/DeviceNode";
import { TopoNode } from "../Topology/TopoNode";
import { HashSet } from "../Utils/HashSet";
import { List } from "../Utils/List";
import { LinkMember } from "../Core/LinkMember";
import { Link } from "../Core/Link";

export class DeviceConnection extends LinkConnection {
	private _linkMembers: HashSet<LinkMember>;

	public get Node(): TopoNode {
		return this.DeviceNode;
	}

	public DeviceNode: DeviceNode;

	constructor(node: DeviceNode, link: Link, linkMembers: List<LinkMember>) {
		super(link);
		this.DeviceNode = node;
		this._linkMembers = new HashSet<LinkMember>(linkMembers);
	}

	public get LinkMembers(): List<LinkMember> {
		return this._linkMembers.ToList();
	}

	public get DisplayName(): string {
		var text = '';

		this._linkMembers.ForEach((linkMember) => {
			if (!!text)
				text += '\r\n';

			if (linkMember.IfEntry != null)
				text += linkMember.IfEntry.ShortDisplayName;
		});

		return text;
	}
}
